<template>
  <div v-if="visible" class="br-admin-dlg" role="presentation">
    <div class="br-admin-dlg__scrim" @click="onScrim"></div>
    <div
      class="br-admin-dlg__panel"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="titleId"
    >
      <div class="br-admin-dlg__copy">
        <p
          :id="titleId"
          class="br-admin-dlg__title"
          v-html="title"
        ></p>
        <p
          v-if="body"
          class="br-admin-dlg__body"
          v-html="body"
        ></p>
      </div>
      <div class="br-admin-dlg__footer">
        <button
          v-if="!hideCancel"
          type="button"
          class="br-admin-dlg__btn br-admin-dlg__btn--ghost"
          :disabled="submitting"
          @click="onCancel"
        >
          {{ cancelLabel }}
        </button>
        <button
          type="button"
          class="br-admin-dlg__btn"
          :class="confirmBtnClass"
          :disabled="submitting"
          @click.stop="onConfirm"
        >
          {{ confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
let confirmModalSeq = 0;

const CONFIRM_VARIANTS = {
  primary: 'br-admin-dlg__btn--primary',
  approve: 'br-admin-dlg__btn--approve',
  reject: 'br-admin-dlg__btn--reject',
};

export default {
  name: 'BrConfirmModal',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    body: { type: String, default: '' },
    cancelLabel: { type: String, default: '' },
    confirmLabel: { type: String, default: '' },
    /** primary | approve | reject */
    confirmVariant: {
      type: String,
      default: 'primary',
      validator: (value) => Object.prototype.hasOwnProperty.call(CONFIRM_VARIANTS, value),
    },
    submitting: { type: Boolean, default: false },
    /** true = 仅确认按钮（结果弹窗） */
    hideCancel: { type: Boolean, default: false },
    /** false = 点遮罩不关闭（须点按钮） */
    closeOnScrim: { type: Boolean, default: true },
  },
  data() {
    confirmModalSeq += 1;
    return {
      titleId: `br-confirm-title-${confirmModalSeq}`,
    };
  },
  computed: {
    confirmBtnClass() {
      return CONFIRM_VARIANTS[this.confirmVariant] || CONFIRM_VARIANTS.primary;
    },
  },
  methods: {
    onCancel() {
      if (this.submitting) {
        return;
      }
      this.$emit('cancel');
    },
    onScrim() {
      if (!this.closeOnScrim) {
        return;
      }
      this.onCancel();
    },
    onConfirm() {
      if (this.submitting) {
        return;
      }
      this.$emit('confirm');
    },
  },
};
</script>
